import React from 'react'
import * as Styled from './RouteContainer.styles'

const RouteContainer: React.FC<Styled.ContainerProps> = ({ children, ...rest }) => (
  <Styled.Container {...rest} maxWidth={false}>{children}</Styled.Container>
)

export { RouteContainer }
